import { introAssets } from '../constants/assets';
import { partnerPageFeatures } from '../data/siteContent';

function PartnersPage() {
  return (
    <section className="page-section" aria-labelledby="partners-title">
      <div className="partner-page-hero">
        <div>
          <span className="section-kicker">말타파트너스</span>
          <h1 id="partners-title">승마장 운영과 홍보를 더 가볍게</h1>
          <p>
            회원 관리, 마필 관리, 마장 관리, 프로모션까지 PC와 모바일에서 함께 운영할
            수 있는 파트너 서비스를 준비합니다.
          </p>
          <a className="primary-action" href="/support">
            파트너 상담하기
          </a>
        </div>
        <img src={introAssets.management} alt="" aria-hidden="true" />
      </div>

      <div className="service-grid">
        {partnerPageFeatures.map((item) => (
          <article className="surface-card" key={item.title}>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default PartnersPage;
